import * as L from 'leaflet';
import { faPage } from '@fortawesome/pro-regular-svg-icons';
import { clickOutsideHandler, createBasicLeafletIconButton, toggleActiveClass } from './helpers';

export class ControlPagination extends L.Control {
  private pagination: HTMLElement;
  private isOpen = false;
  private anchorElement: HTMLElement;
  private pages: number = 0;

  constructor(public options: Partial<L.ControlOptions> & { activeIndex: number, pages: number, elementId: string }) {
    super(options);
    this.pages = options.pages;
  }

  initialize(options: Partial<L.ControlOptions> & { activeIndex: number, pages: number, elementId: string }) {
    this.pagination = L.DomUtil.get(options.elementId);
  }

  onAdd(map: L.Map) {
    const container = L.DomUtil.create('div', 'position-relative');
    const anchorElement = createBasicLeafletIconButton(faPage, (this.options.activeIndex || 1).toString());
    this.anchorElement = anchorElement;

    L.DomEvent.disableClickPropagation(this.pagination);
    L.DomEvent.disableScrollPropagation(this.pagination);
    // 32: size of "page" item, 4: space between every item, 12: padding + space to right
    this.pagination.style.left = `-${(this.pages * 32) + (4 * this.pages - 1) + 12}px`;
    this.pagination.style.top = '-4px';

    L.DomEvent.on(anchorElement, 'click', () => {
      this.togglePagination();
      toggleActiveClass(container);
    });

    container.append(anchorElement);
    container.append(this.pagination);

    clickOutsideHandler(
      [container],
      () => {
        if (this.isOpen) {
          this.togglePagination();
          toggleActiveClass(container);
        }
      },
      map.getContainer());

    return container;
  }

  togglePagination() {
    this.isOpen = !this.isOpen;

    this.pagination.style.visibility = this.isOpen ? 'visible' : 'collapse';
  }

  updateIndex(index: number) {
    this.options.activeIndex = index;
    const text: HTMLElement = this.anchorElement.querySelector('.fa-layers-text');

    if(text) {
      text.innerHTML = this.options.activeIndex.toString();

      if(this.options.activeIndex > 9) {
        text.style.fontSize = '0.6rem'
      } else {
        text.style.fontSize = '0.7rem'
      }
    }
  }
}
